import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ListRolesService {

  constructor(
    private httpClient: HttpClient
  ) { }

  onGetApplications() {
    return this.httpClient.get(`/vd/get/allApplications`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status === 200 && response.data?.length > 0) {
            return response.data;
          } else {
            return [];
          }
        })
      );
  }

  onSaveAppRoleCompanyMapping(payload: any) {
    return this.httpClient.post(`/vd/application/company/roles/save`, payload)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          return response.status === 200;
        })
      );
  }

}
